<template>
  <div>
    <el-dialog
      title="商家控款设置"
      width="600px"
      :visible.sync="isShow"
      :before-close="handleCLose"
    >
      <el-row :gutter="12" type="flex">
        <el-col>
          <el-upload
            ref="supplyGoodsQuantity"
            :action="actionGoodsQuantity"
            :auto-upload="true"
            accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :limit="1"
            name="excel"
            :show-file-list="false"
            :on-success="handleQuantitySuccess"
            with-credentials
          >
            <el-button size="mini" type="primary">导入商家控款数量</el-button>
          </el-upload>
        </el-col>
        <el-col>
          <el-button size="mini" type="info" @click="handleTempDownload">
            下载商家控款数量模板
          </el-button>
        </el-col>
        <el-col>
          <el-button size="mini" type="success" @click="handleListDownload">
            导出商家控款数量
          </el-button>
        </el-col>
        <el-col>
          <el-button size="mini" type="primary" @click="handleViewLog">
            查看日志
          </el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog :visible.sync="showDialogLog" title="操作日志">
      <YsDataTable
        v-model="refreshLog"
        :init-params="initParamsLog"
        :fetch-method="fetchMethodLog"
        :columns="columnsLog"
        :use-pagination="false"
        use-data-field
        max-height="500"
      ></YsDataTable>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import rules from "@/const/rules.js";
import { openDownloadWindow } from "@/utils/export.js";
import {
  getDownMerchantControlConfigTemplate,
  postExportPaymentControlConfig,
  getGetMerchantControlConfigLogs,
} from "@/openapi/erp/AdminSetting.js";

export default {
  name: "SupplyControlModelDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules,
      form: {},
      isShow: false,
      action: `${apiBaseURL}/erp/Supply/importSupplyUpdateFile`,
      actionGoodsQuantity: `${apiBaseURL}/erp/AdminSetting/importPaymentControlConfig`,
      showDialogLog: false,
      refreshLog: false,
      fetchMethodLog: getGetMerchantControlConfigLogs,
      columnsLog: [
        {
          label: "事件",
          prop: "action_type",
        },
        {
          label: "内容",
          prop: "action_desc",
        },
        {
          label: "操作人",
          prop: "action_admin",
        },
        {
          label: "时间",
          prop: "create_time",
        },
      ],
    };
  },
  watch: {
    show() {
      this.isShow = this.show;
    },
  },
  methods: {
    handleQuantitySuccess(res) {
      if (res.code === 200) {
        this.$message.success("导入成功");
      } else {
        this.$message.e(res.msg);
        //  导入错误自动导出错误信息
        if (res.data.error_file) {
          openDownloadWindow(res.data.error_file);
        }
      }
      this.$refs.supplyGoodsQuantity.clearFiles();
    },
    handleCLose() {
      this.$emit("close", {
        refresh: true,
      });
    },
    handleTempDownload() {
      getDownMerchantControlConfigTemplate()
        .then(openDownloadWindow)
        .catch(this.$noop);
    },
    handleListDownload() {
      postExportPaymentControlConfig()
        .then(openDownloadWindow)
        .catch(this.$noop);
    },
    handleViewLog() {
      this.showDialogLog = true;
      this.refreshLog = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/supply/components/SupplyControlModelDialog.vue